// 只允许登录、注册页面供游客访问；受保护页面由全局路由守卫统一检查。
export function hasAuthToken() {
  try {
    const token = window.localStorage.getItem('token')
    return Boolean(token && token.trim() && token !== 'null' && token !== 'undefined')
  } catch (e) {
    return false
  }
}

// 登录/注册成功后只允许恢复站内路径，避免从 URL 参数跳到外部地址。
export function getPostLoginRedirect(route) {
  const value = route && route.query && route.query.redirect
  if (typeof value !== 'string') return '/account'

  const target = value.trim()
  if (!target || target.charAt(0) !== '/' || target.indexOf('//') === 0 || target.indexOf('\\') >= 0) {
    return '/account'
  }
  for (let i = 0; i < target.length; i++) {
    if (target.charCodeAt(i) < 32) return '/account'
  }

  const pathname = target.split(/[?#]/)[0].toLowerCase()
  if (pathname === '/auth/login' || pathname === '/auth/register' ||
      pathname === '/login' || pathname === '/register') {
    return '/account'
  }
  return target
}
